import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { IoArrowBack, IoShareSocial } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

import { db, auth } from '../firebase';
import { doc, getDoc, collection, onSnapshot, where, query } from 'firebase/firestore';

import styles from './TeacherProfile.module.css';

import BlueButton from '../component/ui/BlueButton';
import DotsLoader from '../component/ui/Visual-utilities/DotsLoader';
import ListQuestions from '../component/questionsStuff/ListQuestions';
import NewQuestion from '../component/questionsStuff/NewQuestion';
import Signin from '../component/Signin';
import { BsWhatsapp } from 'react-icons/bs';
import DropUpMenu from '../component/ui/DropUpMenu';


import {
    EmailShareButton,
    FacebookMessengerShareButton,
    FacebookShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";

import { MdAlternateEmail } from 'react-icons/md';
import { FaFacebookF, FaFacebookMessenger, FaInstagram, FaLink, FaLinkedinIn, FaTelegramPlane, FaTwitter, FaWhatsapp } from 'react-icons/fa';

export default function TeacherProfile() {
    const [teacherData, setTeacherData] = useState(false);
    const [relatedQuest, setRelatedQuest] = useState(false);
    const [askButton, setAskButton] = useState(false);
    const [signIn, setSignIn] = useState(true);
    const [loading, setLoading] = useState(true);

    const [shareModal, setShareModal] = useState(false);


    let { id } = useParams();
    let { name } = useParams();
    const teacherRef = doc(db, 'roles', id);
    const questionRef = collection(db, 'questions');

    const navigate = useNavigate();


    const getRelatedQuest = async () => {
        const uid = auth.currentUser?.uid;
        if (uid) {
            const q = query(questionRef,
                where("sender_id", "==", uid),
                where("target_teacher", "==", id));

            onSnapshot(q,
                snapshot => {
                    setRelatedQuest(snapshot.docs.map((docu) => ({ ...docu.data(), question_id: docu.id })));
                }
            );
        }
    }

    const getTeacherData = async () => {
        const docSnap = await getDoc(teacherRef);
        if (docSnap.exists()) {
            setTeacherData(docSnap.data());
            setLoading(false);
            getRelatedQuest();
        }
    }

    const handleShare = async () => {
        setShareModal(true)
        if (navigator.share) {

            const blob = await (await fetch(teacherData.profile_url)).blob()

            const shareData = {
                title: name + '\'s profile',
                text: `Maximize learning with ${name} on Questa!`,
                url: window.location.href,
            }


            if (!!blob) {
                shareData.files = [
                    new File([blob], 'profile.png', {
                        type: blob.type,
                    }),
                ];
            }
            navigator.share(shareData)
                .then(() => console.log("Content shared successfully."))
                .catch(error => console.log("Error sharing content:", error));
        }
        else {
            console.log("The Web Share API is not supported in this browser.");
        }
    }

    const askTeacher = () => {
        if (auth.currentUser) {
            setAskButton(true);
        } else {
            setSignIn(false);
        }
    }





    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate('/', { replace: true }); // the current entry in the history stack will be replaced with the new one with { replace: true }
        }
    };



    useEffect(() => {
        getTeacherData();

        if (auth.currentUser) {
            setSignIn(true);
        }
    }, [auth.currentUser])


    return (!signIn) ?


        <Signin isSigningUp={(state) => {  console.log('is sign up state', state) }}
            refreshUser={() => auth.currentUser.getIdToken(true)} />
        :


        <div className='MainSplitContainer' >

            <div className={'leftContainer '}>

                <div className="p-2 m-1 bg-white pb-3">
                    {/* ----------------- START header ---------------- */}
                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <button onClick={handleBack}><IoArrowBack size='25' /></button>

                        <DropUpMenu opened={shareModal} close={() => setShareModal(false)}>
                            <div className='p-5'>
                            <div className=' d-flex flex-column justify-content-center align-items-center  share-container' >
                                <p>Share the profile social media</p>
                                <div className='d-flex justify-content-center'
                                style={{gap:'10px'}}>
                                    <TwitterShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}                                    >
                                        <FaTwitter size={25} />
                                    </TwitterShareButton>

                                    
                                    
                                    <FacebookMessengerShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaFacebookMessenger size={25} />
                                    </FacebookMessengerShareButton>

                                    <FacebookShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaFacebookF size={25} />
                                    </FacebookShareButton>

                                    <EmailShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <MdAlternateEmail size={25} />
                                    </EmailShareButton>
                                    <LinkedinShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaLinkedinIn size={25} />
                                    </LinkedinShareButton>
                                    
                                    <InstapaperShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaInstagram size={25} />
                                    </InstapaperShareButton> 

                                    <LineShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaLink size={25} />
                                    </LineShareButton>

                                    <WhatsappShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaWhatsapp size={25} />
                                    </WhatsappShareButton>

                                    <TelegramShareButton
                                        url={'https://www.example.com'}
                                        quote={'Dummy text!'}
                                        hashtag="#muo"
                                        resetButtonStyle={false}
                                    >
                                        <FaTelegramPlane size={25} />
                                    </TelegramShareButton>
                                    

                                </div>
                            </div>
                            </div>
                        </DropUpMenu>

                        {<button onClick={handleShare}><p className={styles.blueTxt} style={{ marginRight: 5, marginBottom: 0 }}>Share Profile</p><IoShareSocial size='25' /></button>}
                    </div>
                    {/* ----------------- END header ---------------- */}

                    {/* ----------------- START profile info ------------ */}
                    {loading ?

                        <div className="p-5"> <DotsLoader color={'linear-gradient(180deg, #0C99FF 0%, rgba(12, 80, 255, 0.97) 100%)'} /> </div>

                        :

                        <div className="d-flex flex-row align-items-center justify-content-center ">
                            {teacherData !== false &&
                                <div className={styles.imageContainer + " d-inline-block w-70 h-70 me-2"}>
                                    <img src={teacherData.profile_url} alt='teacher' className={styles.profilePic} />
                                    <img src={teacherData.organisation?.picture} alt='organisation' className={styles.organisationPic} />
                                </div>}
                            <div className='mt-2 mb-2'>
                                <h5 className="fw-bold text-black">{teacherData.name}</h5>
                                Grade speciality: {teacherData.grade_speciality?.map((item, index) => {
                                    return <span key={index} className={styles.blueTxt}> {item}, </span>
                                })}<br />
                                Subject speciality: {teacherData.subject_speciality?.map((item, index) => {
                                    return <span key={index} className={styles.subject}><span className={styles.blueTxt}>{item}</span>  </span>
                                })} <br />
                                <b className="text-black">{teacherData.total_answered}</b> answered questions
                            </div>
                        </div>}
                    <p className="text-center">{teacherData.description}</p>

                    <BlueButton onClick={askTeacher}>Ask this teacher now</BlueButton>
                    {askButton && <NewQuestion onClick={() => setAskButton(false)} targetTeacher={id} />}
                    {/* ----------------- END profile info ------------ */}
                </div>

                {/* ----------------- START related questions ------------ */}
                {relatedQuest && <h6 className="mt-4 ms-3 text-muted">Related Question:</h6>}
                {
                    relatedQuest !== false &&
                    <ListQuestions data={relatedQuest} onClick={() => { }} />
                }
                {/* ----------------- END related questions ------------ */}

                <div >




                </div> </div>


            <div className="rightContainer">
                <div className="not_sign__shape">
                    <img className="circle" src="/assets/img/icon/sign/circle.png" alt="img not found" />
                    <img className="zigzag" src="/assets/img/icon/sign/zigzag.png" alt="img not found" />
                    <img className="dot" src="/assets/img/icon/sign/dot.png" alt="img not found" />
                    <img className="flower" src="/assets/img/icon/sign/flower.png" alt="img not found" />

                    <div className="center_logo d-flex flex-column justify-content-center2 align-content-center">
                        <img className='logo' src="/assets/img/logo/questa logo.png" alt="img not found" />
                        <p className=' under_logo text-center'>For any help feel free to reach us out on<a className="" href='https://wa.me/message/EQMDVYMG5NXJK1'><br /><b> 81 184 763<BsWhatsapp /></b> </a></p>
                    </div>


                </div>
            </div>
        </div>



}
